<template>
  <v-container>
    <h1><b> Iklan</b></h1>
    <center v-if="loader">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </center>
    <br />
    <div v-if="!loader">
      <IklanBaris :idIklan="idIklan" v-if="hits.id_mst_iklan_jenis == 1" />
      <IklanAss :idIklan="idIklan" v-if="hits.id_mst_iklan_jenis == 5" />
      <div v-if="hits.id_mst_iklan_jenis == 2">
        <IklanTbSatuanTerbuka
          :idIklan="idIklan"
          v-if="(hits.id_mst_iklan_type == 1) & (hits.id_mst_type_tb == 1)"
        />
        <IklanTbSatuanTertutup
          :idIklan="idIklan"
          v-if="(hits.id_mst_iklan_type == 1) & (hits.id_mst_type_tb == 2)"
        />
        <IklanTbPaketanTerbuka
          :idIklan="idIklan"
          v-if="(hits.id_mst_iklan_type == 2) & (hits.id_mst_type_tb == 1)"
        />
        <IklanTbSPaketanTertutup
          :idIklan="idIklan"
          v-if="(hits.id_mst_iklan_type == 2) & (hits.id_mst_type_tb == 2)"
        />
        <IklanLelang
          :idIklan="idIklan"
          v-if="(hits.id_mst_iklan_type == 3) "
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import IklanBaris from '@/components/IklanBaris.vue';
import IklanAss from '@/components/IklanAss.vue';
import IklanTbSatuanTerbuka from '@/components/TbSatuanTerbuka.vue';
import IklanTbSatuanTertutup from '@/components/TbSatuanTertutup.vue';
import IklanTbPaketanTerbuka from '@/components/TbPaketanTerbuka.vue';
import IklanTbSPaketanTertutup from '@/components/TbPaketanTertutup.vue';
import IklanLelang from '@/components/IklanLelang.vue';
export default {
  name: 'iklan',
  components: {
    IklanBaris,
    IklanAss,
    IklanTbSatuanTerbuka,
    IklanTbSatuanTertutup,
    IklanTbPaketanTerbuka,
    IklanTbSPaketanTertutup,
    IklanLelang
  },
  data: () => ({
    hits: [],
    idIklan: '',
    loader: false
  }),
  methods: {
    async getDtlIklanTB() {
      // console.log('ini iklannya', this.item)
      await this.$req
        .get(this.$root.$baseapi.iklan+'/iklan/v3/iklan_tb_mokas', {
          params: {
            id: this.$route.query.id
          }
        })
        .then(response => {
          let { data } = response.data;
          this.hits = data;
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async getDtlIklanIB() {
      // console.log('ini iklannya', this.item)
      await this.$req
        .get(this.$root.$baseapi.iklan+'/iklan/v3/iklan_hp_mokas', {
          params: {
            id: this.$route.query.id
          }
        })
        .then(response => {
          let { data } = response.data;
          this.hits = data;
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async getDtlIklanAS() {
      // console.log('ini iklannya', this.item)
      await this.$req
        .get(this.$root.$baseapi.iklan+'/iklan/v3/iklan_as', {
          params: {
            id: this.$route.query.id
          }
        })
        .then(response => {
          let { data } = response.data;
          this.hits = data;
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async getDtlIklan() {
      var params = new URLSearchParams();
      params.append('id', this.$route.query.id);
      params.append('limit', 1);

      params.append('id_mst_iklan_type', 1);
      params.append('id_mst_iklan_type', 2);
      params.append('id_mst_iklan_type', 3);

      var request = {
        params: params
      };

      await this.$req
        .get(this.$root.$baseapi.search+'/search/v4/search', request)
        .then(response => {
          let data = response.data;
          let { hits } = data.hits;
          this.hits = hits[0]._source;
          // console.log(this.hits)
          // console.log('ini iklannya', this.hits);
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    }
  },
  async created() {
    this.loader = true;
    try {
      console.log(this.$route.query.jenis)

      if (this.$route.query.jenis == 'Tawar Bersama') {
        this.getDtlIklanTB();
      } else if (this.$route.query.jenis == 'Iklan Baris') {
        this.getDtlIklanIB();
      }else if (this.$route.query.jenis == 'Aksesoris ') {
        this.getDtlIklanAS();
      }else{
        this.getDtlIklan()
      }
      this.idIklan = this.$route.query.id;
      setTimeout(_ => (this.loader = false), 700);
    } catch (error) {
      console.log(error);
      setTimeout(_ => (this.loader = false), 700);
    }
  }
};
</script>

<style></style>
